













import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import {
  Product, ProductResource,
} from '@/api/product';

@Component({
  computed: mapState([
    'fiId',
  ]),
})
export default class ProductSelect extends Vue {
  loading: boolean = true;

  products: Product[] = [];

  fiId!: string;

  selectedProduct: Product | null = null;

  @Prop({ default: [] })
  productTypeFilter!: string[];

  @Prop({ default: false })
  includeSelectAllOption!: boolean;

  @Inject('ProductResource')
  productResource!: ProductResource;

  mounted() {
    this.loadData();
  }

  @Watch('fiId')
  loadData() {
    this.selectedProduct = null;
    this.loading = true;
    this.loadProducts();
  }

  async loadProducts() {
    this.products = [];
    await this.productResource.getAllProducts(this.fiId).then((returnedProducts: Product[]) => {
      returnedProducts.forEach((product: Product) => {
        if (!this.productTypeFilter.includes(product.productMapping.productType)) {
          this.products.push(product);
        }
      });
      if (this.includeSelectAllOption) {
        // Add a dummy product representing "all"
        this.products.push({
          id: -1,
          active: false,
          eocEmailEnabled: false,
          launchDate: '',
          linkedAccountMethodology: '',
          kasasaTunesConfiguration: {
            signUpBonusAmount: '',
            signUpBonusExpirationDays: 0,
          },
          serviceFee: false,
          serviceFeeAmount: '',
          qualRewardGroups: [],
          hasAssociatedResults: false,
          productMapping: {
            id: -1,
            coreAccountProductTypes: [],
            accountType: '',
            productType: 'ALL',
            kasasaBranded: '',
            hasAssociatedAccounts: false,
            externalProductMappingId: null,
            productSubType: '',
            productAcquisitionSource: '',
            productClassification: '',
            fiProductName: 'All Products',
          },
        });
      }
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading = false;
    });
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  onNewSelection() {
    this.$emit('input', this.selectedProduct);
  }
}
